import React, { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import TopFieldContent from '../TopFieldContent';
import ErrorMessage from '../ErrorMessage';
import useFormName from '../../../../Hooks/useFormName';
import DoctorSelect from '../../../../Modules/Doctor/Components/DoctorSelect/DoctorSelect';
import InputWrapper from '../InputWrapper/InputWrapper';

interface Props {
	label?: string;
	name: string;
	isRequired?: boolean;
	className?: string;
	doctorId?: string;
	roleKeys?: string[];
	approved?: boolean;
	isWrapped?: boolean;
}

const DoctorSelectField: React.FC<Props> = ({
	name,
	label,
	className,
	isRequired,
	doctorId = '',
	roleKeys,
	approved,
	isWrapped,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: {
			value: doctorId,
		},
	});

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<DoctorSelect {...field} roleKeys={roleKeys} approved={approved} />
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default DoctorSelectField;
